import axios from 'axios'
import { AllCompanies } from '../features/bedManagement/endpoints/EndPoints'
import KeycloakService from '../utils/keycloakService'
import { sucessErrorMsg } from './constants'

export const GetAllCompanies = async () => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${AllCompanies}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: response?.data?.company,
      success: true,
      message: sucessErrorMsg?.companySucessMsg,
    }
  } catch {
    return {
      data: null,
      success: false,
      message: sucessErrorMsg?.companyErrorMsg,
    }
  }
}
